import SubmitCoverLetter from "./SubmitCoverLetter";

export default SubmitCoverLetter;